import React, { useState } from 'react';
import {
  Drawer,
  Box,
  Typography,
  IconButton,
  TextField,
  Button
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
import { updateUser, fetchUser } from '../../../store/Slices/userSlice';

const NicknameDrawer = ({ open, onClose }) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const user = useSelector((state) => state.user.data); // جلب بيانات المستخدم الحالية
  const [nickname, setNickname] = useState(user?.username || '');
  const [error, setError] = useState('');

  const handleSave = async () => {
    if (nickname.length < 3 || nickname.length > 15) {
      setError('Nickname must be between 3 and 15 characters.');
      return;
    }

    if (nickname === user?.username) {
      setError('No changes detected.');
      return;
    }

    try {
      // إرسال الاسم الجديد فقط دون تغيير البريد الإلكتروني
      await dispatch(updateUser({ username: nickname, email: user.email })).unwrap();
      
      // جلب البيانات المحدثة من السيرفر
      await dispatch(fetchUser()); 

      onClose(); // إغلاق النافذة بعد التحديث
    } catch (err) {
      if (err.includes('Username already taken')) {
        setError('This username is already in use.');
      } else {
        setError(err || 'Failed to update nickname.');
      }
    }
  };

  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      sx={{
        '& .MuiDrawer-paper': {
          borderTopLeftRadius: 16,
          borderTopRightRadius: 16,
          padding: 2,
        },
      }}
    >
      {/* Header */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6">Set nickname</Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>

      {/* Input Field */}
      <TextField
        fullWidth
        value={nickname}
        onChange={(e) => setNickname(e.target.value)}
        variant="outlined"
        sx={{ mb: 2 }}
        inputProps={{ maxLength: 15 }}
        error={!!error}
        helperText={error}
      />
      <Typography variant="body2" color="text.secondary">{nickname.length}/15</Typography>

      {/* Save Button */}
      <Button
        variant="contained"
        color="primary"
        fullWidth
        sx={{
          mt: 2,
          bgcolor: theme.palette.brand.main,
          color: theme.palette.getContrastText(theme.palette.brand.main),
          '&:hover': { bgcolor: theme.palette.brand.main },
        }}
        onClick={handleSave}
      >
        Save
      </Button>
    </Drawer>
  );
};

export default NicknameDrawer;
